export enum IOrgWorkingSessionsAnalyticsActivityEnum {
  SessionId = 'OrgWorkingSessionsActivity.session_id',
  LocalSessionEnd = 'OrgWorkingSessionsActivity.local_session_end',
  LocalSessionStartWeek = 'OrgWorkingSessionsActivity.local_session_start_week',
  SessionDuration = 'OrgWorkingSessionsActivity.session_duration',
  SessionCallCount = 'OrgWorkingSessionsActivity.session_call_count',
  SessionFocusDuration = 'OrgWorkingSessionsActivity.session_focus_duration',
  SessionActivityDuration = 'OrgWorkingSessionsActivity.session_activity_duration',
  ActivityCount = 'OrgWorkingSessionsActivity.activity_count',
  ContextSwitches = 'OrgWorkingSessionsActivity.context_switches',
  FocusScore = 'OrgWorkingSessionsActivity.focus_score_v2',
  LocalSessionStart = 'OrgWorkingSessionsActivity.local_session_start',
  LocalSessionStartDate = 'OrgWorkingSessionsActivity.local_session_start_date',
  FocusPercentage = 'OrgWorkingSessionsActivity.focusPercentage',
  DigitalIntensity = 'OrgWorkingSessionsActivity.digitalIntensity',
  SessionCallDuration = 'OrgWorkingSessionsActivity.session_call_duration',
  TotalActivityDuration = 'OrgWorkingSessionsActivity.totalActivityDuration',
  TotalFocusDuration = 'OrgWorkingSessionsActivity.totalFocusDuration',
  TotalSessionCallDuration = 'OrgWorkingSessionsActivity.totalSessionCallDuration',
  UserId = 'OrgWorkingSessionsActivity.userid',
  CumulativeDailyAverageScreentime = 'OrgWorkingSessionsActivity.cumulativeDailyAverageScreentime',
  CumulativeDailyAverageWorkingHours = 'OrgWorkingSessionsActivity.cumulativeDailyAverageWorkingHours',
  CumulativeWeeklyAverageScreentime = 'OrgWorkingSessionsActivity.cumulativeDailyAverageScreentime',
  CumulativeWeeklyAverageWorkingHours = 'OrgWorkingSessionsActivity.cumulativeDailyAverageWorkingHours',
  WeekCount = 'OrgWorkingSessionsActivity.weekCount',
  DayCount = 'OrgWorkingSessionsActivity.dayCount',
  UserCount = 'OrgWorkingSessionsActivity.userCount',
  CallWeekCount = 'OrgWorkingSessionsActivity.callWeekCount',
  CallDayCount = 'OrgWorkingSessionsActivity.callDayCount',
  WeekDayIndex = 'OrgWorkingSessionsActivity.weekday_index',
  TotalDuration = 'OrgWorkingSessionsActivity.totalDuration',
  ObjectType = 'OrgWorkingSessionsActivity.objecttype',
  DepartmentId = 'OrgWorkingSessionsActivity.departmentid',
  UpdatedAt = 'OrgWorkingSessionsActivity.updatedAt',
}

export enum IOrgWorkingSessionsAnalyticsActivitySegmentsEnum {
  monday = 'OrgWorkingSessionsActivity.monday',
  tuesday = 'OrgWorkingSessionsActivity.tuesday',
  wednesday = 'OrgWorkingSessionsActivity.wednesday',
  thursday = 'OrgWorkingSessionsActivity.thursday',
  friday = 'OrgWorkingSessionsActivity.friday',
  saturday = 'OrgWorkingSessionsActivity.saturday',
  sunday = 'OrgWorkingSessionsActivity.sunday',
}
